import React, { useEffect, useState } from 'react';
import { Button, Frame, FrameTitle, SubTitle, Title, SubmitScore, Timer } from 'Pages/HazardPerceptionGame/Components';
import { Loading } from 'Components/Partials';

import ScoresApi from 'Services/Api/Site/Scores';
import { asset } from "Services/BaseHelpers";

const GameOver = ({ setScreen, score }) => {
    const [loading, setLoading] = useState(false);
    const [scores, setScores] = useState(null);

    useEffect(() => {
        (async () => {
            setLoading(true);

            const response = await ScoresApi.get(null, {
                game_id: 'hazard_perception',
                order_by: 'score',
                order: 'asc',
                limit: 10
            });

            if (response.success) {
                setLoading(false);
                setScores(response.data.data);
            }
        })();
    }, []);

    return (
        <div className="w-full h-full flex justify-center items-center">
            <Frame>
                <div
                    className="bg-white bg-opacity-10 rounded-xl px-8 flex items-center justify-center text-center flex-col py-4 lg:py-12 xl:py-24"
                >
                    <FrameTitle>
                        CAM 1
                    </FrameTitle>

                    <Title>TOP 10</Title>
                    <SubTitle>Leaderboard</SubTitle>

                    <div className="mt-6 mb-8">
                        <Button
                            size="small"
                            onClick={() => setScreen('welcome')}
                        >
                            New Game
                        </Button>
                    </div>

                    {loading && <Loading className="text-white"/>}

                    {!loading && (!scores || scores.length === 0) && (
                        <p className="text-xs md:text-base xl:text-lg rubik-regular text-app-yellow text-center mt-3 xl:mt-5 mb-8">
                            You are the first player!
                        </p>
                    )}

                    {!loading && scores && scores.length !== 0 && (
                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 lg:gap-8 mb-10">
                            <RenderLeaderboard scores={scores.slice(0, 5)} addToIndex={1}/>
                            <RenderLeaderboard scores={scores.slice(5)} addToIndex={6}/>
                        </div>
                    )}
                </div>
            </Frame>
        </div>
    );
};

const RenderLeaderboard = ({ scores, addToIndex }) => {
    return (
        <div className="flex flex-col gap-4">
            {scores.map((score, i) => (
                <div
                    className="flex flex-row items-center gap-3"
                    key={i}
                >
                    <RenderRank rank={i + addToIndex}/>

                    {/*<img*/}
                    {/*    className="h-6 w-6 xl:h-8 xl:w-8"*/}
                    {/*    src={asset('/images/pacman/profile.png')}*/}
                    {/*/>*/}

                    <div className={`
                            w-full flex flex-row justify-between items-center gap-2 px-4 py-1 bg-app-turquoise
                            text-white nobblee-regular uppercase rounded-md
                        `}>
                            <span className="text-md xl:text-lg tracking-wide">
                                {score.nickname}
                            </span>

                        <span className="text-xs xl:text-sm rubrik-regular">
                                {score.score}
                            </span>
                    </div>
                </div>
            ))}
        </div>
    );
};

const RenderRank = ({ rank }) => {
    switch (rank) {
        case 1:
            return (
                <img
                    alt={rank}
                    className="h-6 w-6 xl:h-8 xl:w-8"
                    src={asset('/images/pacman/1st.png')}
                />
            );
        case 2:
            return (
                <img
                    alt={rank}
                    className="h-6 w-6 xl:h-8 xl:w-8"
                    src={asset('/images/pacman/2nd.png')}
                />
            );
        case 3:
            return (
                <img
                    alt={rank}
                    className="h-6 w-6 xl:h-8 xl:w-8"
                    src={asset('/images/pacman/3rd.png')}
                />
            );
        default:
            return (
                <div className="h-6 xl:h-8 w-6 xl:w-8 text-center text-md text-white retro-gaming">
                    {rank}
                </div>
            );
    }
};

export default GameOver;
